import React, {createContext, useContext, useState} from 'react';

interface TaskHeaderSlotContextType {
  slot: React.ReactNode;
  setSlot: (node: React.ReactNode) => void;
}

const TaskHeaderSlotContext = createContext<TaskHeaderSlotContextType>({
  slot: null,
  setSlot: () => undefined,
});

export const TaskHeaderSlotProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [slot, setSlot] = useState<React.ReactNode>(null);
  return (
    <TaskHeaderSlotContext.Provider value={{slot, setSlot}}>
      {children}
    </TaskHeaderSlotContext.Provider>
  );
};

export const useTaskHeaderSlot = () => useContext(TaskHeaderSlotContext);
